// src/components/SimpleFormComponents/SimpleEntityCompanyFormBR.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleEntityUid from '../../SimpleEntityUid';
import SimpleInput from '../../SimpleInput';
import SimplePhone from '../../SimplePhone';
import SimpleEmail from '../../SimpleEmail';
import SimpleBirthdate from 'components/SimpleComponents/SimpleBirthdate';
import SimpleSegmentIndustry from 'components/SimpleComponents/SimpleSegmentIndustry';
import useSubscriptionLocale from 'hooks/useSubscriptionLocale';
import { countryCodeFromLocale } from '../../SimpleEntityUid';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleEntityCompanyFormBR = ({
  style = {},
  subdocumentField,
  companyPhoneProfile,
  countryCode: countryCodeProp,
  unique, // unique company by cnpj/nipc/ein
  searchCnpjByApi = false, // If true, search external APIs for auto-fill

  showCnpjField = true,
  cnpjFieldFirst = true,
  useInModal = false,
}) => {
  const { locale } = useSubscriptionLocale();
  const countryCode = countryCodeProp || countryCodeFromLocale(locale);
  // ---------------------------------------------------------------------------
  // PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  // NOTE: SimplePhone will use phone.countryCode from data, not from parent form

  // ---------------------------------------------------------------------------
  // LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  // Get field label for foundation date based on country
  const foundationLabel = countryCode === 'PT' ? 'constitution_at' : 'foundation_at';

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <>
      <Row gutter={ROW_GUTTER} style={style}>
        {/* TAX ID FIELD - Universal (CNPJ/NIPC/EIN/UID based on country) */}
        {showCnpjField && (
          <Col xs={24} sm={12} lg={6} order={cnpjFieldFirst ? 1 : 2}>
            <SimpleEntityUid
              entityType="company"
              countryCode={countryCode}
              searchCnpjByApi={searchCnpjByApi}
              unique={unique}
              subdocumentField={subdocumentField}
            />
          </Col>
        )}

        {/* TRADE NAME / COMPANY NAME */}
        <Col xs={24} sm={12} lg={6} order={cnpjFieldFirst ? 2 : 1}>
          <SimpleInput
            name="name"
            subdocumentField={subdocumentField}
            label="company"
            repeatOnField="fullName"
            useInitialInAvatar
          />
        </Col>

        {/* FULL COMPANY NAME / LEGAL NAME */}
        <Col xs={24} sm={24} lg={12} order={3}>
          <SimpleInput
            name="fullName"
            label={countryCode === 'PT' ? 'legal_name' : 'company_name'}
            subdocumentField={subdocumentField}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        {/* EMAIL - UNIQUE KEY PREFERRED */}
        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimpleEmail
            name={['email', 'value']}
            label="email"
            subdocumentField={subdocumentField}
          />
        </Col>

        {/* PHONE - SECONDARY IDENTIFIER */}
        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimplePhone
            name={['phone', 'value']}
            label="phone"
            international
            profile={companyPhoneProfile}
            countryCode={countryCode}
          />
        </Col>

        {/* FOUNDATION / CONSTITUTION DATE */}
        <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
          <SimpleBirthdate
            name="foundedAt"
            label={foundationLabel}
            subdocumentField={subdocumentField}
            entityType="company"
          />
        </Col>

        {/* INDUSTRY SEGMENT (BR only) */}
        {countryCode === 'BR' && (
          <Col xs={24} sm={12} lg={useInModal ? 8 : 6}>
            <SimpleSegmentIndustry
              name="segment"
              subdocumentField={subdocumentField}
              label="segment"
            />
          </Col>
        )}
      </Row>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleEntityCompanyFormBR;

// *******************************************************************************
// HELPERS
// *******************************************************************************
